import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [categories, setCategories] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zones, setZones] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {};
      setDataChanging(customerPortfolioB);
      listZones();
    }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo encargado del inventario`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={'logi/inventory-manager'}
        maxWidth={'md'}
        dataForce={{
          base_zone_id: dataChanging.base_zone_id,
        }}
      >
        <GridContainer>
          {/* Codigo */}
          {/* <GridItem xs={12} sm={6}>
            <TextField
              label="codigo"
              fullWidth
              type="text"
              name="code"
              margin="normal"
              value={dataChanging.code || ''}
              onChange={(e) => handleChange('code', e.target.value)}
              required
            />
          </GridItem> */}
          {/* Dni */}
          <GridItem xs={12} sm={12}>
            <TextField
              label="Documento de identidad"
              fullWidth
              name="dni"
              margin="normal"
              defaultValue={dataChanging.dni || ''}
              onKeyPress={onlyInteger}
              inputProps={{ minLength: 8, maxLength: 11 }}
              required
            />
          </GridItem>
          {/* Celular */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Celular"
              fullWidth
              name="phone"
              margin="normal"
              defaultValue={dataChanging.phone || ''}
              onKeyPress={onlyInteger}
              inputProps={{ minLength: 9, maxLength: 9 }}
            />
          </GridItem>

          {/* Nombre completo */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Nombre completo"
              fullWidth
              name="name"
              margin="normal"
              defaultValue={dataChanging.name || ''}
              inputProps={{ minLength: 1, maxLength: 30 }}
              required
            />
          </GridItem>
          {/* FirstName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Nombres"
              fullWidth
              name="FirstName"
              margin="normal"
              defaultValue={dataChanging.FirstName || ''}
              inputProps={{ minLength: 1, maxLength: 30 }}
              required
            />
          </GridItem>
          {/* LastName */}
          <GridItem xs={12} sm={6}>
            <TextField
              label="Apellidos"
              fullWidth
              name="LastName"
              margin="normal"
              defaultValue={dataChanging.LastName || ''}
              inputProps={{ minLength: 1, maxLength: 30 }}
              required
            />
          </GridItem>
        </GridContainer>

        {zones.length > 0 ? (
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(option) => `${option.description}`}
            value={zones.find((item) => item.id === dataChanging.base_zone_id) || null}
            renderInput={(params) => (
              <TextField {...params} label="Zonas" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {
              handleChange("base_zone_id", item ? item.id : null);
            }}
            required
          />
        ) : undefined}
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            value={dataChanging.type || ''}
            inputProps={{
              name: 'type',
              onChange: (e) => handleChange('type', e.target.value),  
            }}
          >
            <MenuItem value="JD">Jefe almacen dia</MenuItem>
            <MenuItem value="JN">Jefe almacen noche</MenuItem>
            <MenuItem value="AD">Auditor</MenuItem>
          </Select>
        </FormControl>
      </Modal>
    </>
  );
});
